<template>
  <div class="recharge-detail">
    <!-- 轮播图区域 -->
    <div class="banner-section">
      <van-swipe class="banner-swipe" :autoplay="10000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <van-image :src="item" fit="cover" class="banner-image" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 商品信息区域 -->
    <div class="info-section">
      <!-- 价格区域 -->
      <div class="price-section">
        <div class="price">
          <span class="price-value">{{ selectPrice }}</span>
          <span class="price-unit">点</span>
        </div>
        <div class="title-tag" v-if="getTitleTag()" :style="{ background: getTitleTag().colorCode }">
          {{ getTitleTag().name }}
        </div>
      </div>

      <!-- 商品名称 -->
      <div class="product-name">
        <span class="brand-name" v-if="detail?.brandName">【{{ detail?.brandName }}】</span>
        <span class="name">{{ specsLsit[0]?.specifications }}</span>
      </div>

      <!-- 标签列表 -->
      <div class="tag-list">
        <span class="tag-item" v-for="(val, index) in getTagList()" :key="index">
          {{ val.name }}
        </span>
      </div>
    </div>

    <!-- 规格选择区域 -->
    <div class="spec-section">
      <div class="spec-item" @click="handleProductList">
        <div class="spec-label">
          <div class="header-line"></div>
          <span class="label-text">品牌</span>
        </div>
        <div class="spec-content">
          <span class="spec-text">{{ detail?.brandName || '请选择品牌' }}</span>
          <van-icon name="arrow" color="#c8c8c8" size="14px" />
        </div>
      </div>
      <div class="spec-item" @click="specPopupOpen">
        <div class="spec-label">
          <div class="header-line"></div>
          <span class="label-text">规格</span>
        </div>
        <div class="spec-content">
          <span class="spec-text">{{ selectGoods || '请选择规格' }}</span>
          <van-icon name="arrow" color="#c8c8c8" size="14px" />
        </div>
      </div>
    </div>

    <!-- 商品详情区域 -->
    <div class="detail-section">
      <div class="section-header">
        <div class="header-line"></div>
        <span class="header-text">商品详情</span>
      </div>
      
      <!-- 商品描述 -->
      <div class="description" v-html="sanitizedDescription"></div>
      
      <!-- 商品图片列表 -->
      <div class="image-list">
        <van-image 
          v-for="(item, index) in goodsDetailImgList" 
          :key="index" 
          :src="item"
          class="detail-image"
        />
      </div>

    </div>

    <!-- 底部操作栏 -->
    <van-goods-action>
      <van-goods-action-icon icon="cart-o" text="购物车" @click="goCar" />
      <van-goods-action-button 
        type="danger" 
        :disabled="cantBuy" 
        :text="textBuy"
        @click="() => specPopupOpen('buyNow')" 
      />
    </van-goods-action>

    <!-- 规格选择弹窗 -->
    <SpecPopupRecharge 
      ref="SpecPopupRecharge" 
      v-if="productDetaiLoad" 
      :goodsType="detail.category1Id && detail.category1Id == '5' ? 'cake' : 'normal'"
      :list="specsLsit" 
      :product-type="productType"
      :venue-list="detail?.venueList" 
      :current-distribution="detail.distributionRuleId" 
      :query-form="detailform"
      :channel-type="2" 
      @submit="handleSpecSubmit"
    />
  </div>
</template>

<script>
import DetailsSpecItem from "./DetailsSpecItem.vue";
import SendType from "../../components/goods/SendType.vue";
import SpecPopupRecharge from "../../components/SpecPopup/SpecPopupRecharge.vue";
import OverlayLoad from "../../components/SpecPopup/OverlayLoad.vue";
import { goMyCart, getGoodsDetail, submitBuyGoodsInfo, goBrandProductList } from "./index.action";
import Utils from "../../utils";
import { sanitizeHtml } from "@/utils/sanitize";
export default {
  name: "DetailsRecharge",
  props: {},
  data() {
    return {
      goodsDetailImgList: [], // 商品详情数组
      bannerList: [], // banner图
      specsLsit: [], // 可选规格列表
      loading: false,
      productDetaiLoad: false, // 详情信息,是否加载完成
      detail: null,
      bannerHeight: 0,
      //商品规格
      show: false,
      selectGoods: "", // 展示所选规格的商品
      sendTypeStr: "", // 展示的配送信息
      detailform: {
        cardId: "",
        cityCode: "",
        brandId: "",
        productId: ""
      },
      cantBuy: false,// 不能买和加入购物车
      textBuy: '立即购买',

      ShopDetail: null,
      userId: "",
      chousetype: "",
      selectPrice: '',
      selectMarketprice: "",
      goodNum: 1, // 商品数量
      specId: this.$route.query.specId, // 规格 id
      shopDetail: "",
      shopId: "",
      shopName: "",
      consigneeName: "",
      consigneePhone: "",
      productType: "", //0 票 1 蛋糕 2 其他
      delivery_amount: "0",
    };
  },
  components: { 
    DetailsSpecItem,
    SendType,
    SpecPopupRecharge,
    OverlayLoad 
  },

  mounted() {
    this.init();
    this.bannerHeight = (document.body.clientWidth || window.innerWidth || document.documentElement.clientWidth)
    var timer = setInterval(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0
      clearInterval(timer);
    }, 200)
  },

  computed: {
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    getTitleTag() {
      let Tag = undefined
      if (this.detail?.labelList) {
        this.detail?.labelList.forEach(element => {
          if (element.smallLabelType == '1') {
            Tag = element
          }
        });
      }
      return Tag
    },
    getTagList() {
      let Tag = []
      if (this.detail?.labelList) {
        this.detail?.labelList.forEach(element => {
          if (element.smallLabelType !== '1') {
            Tag.push(element)
          }
        });
      }
      return Tag
    },
    formNumber(val) {
      if (val) {
        return parseFloat(val).toFixed(2)
      } else return ''

    },
    handleProductList() {
      if (this.detail && this.detail.brandName) {
        goBrandProductList(this.detail.brandName);
      }
    },
    init() {
      this.userId = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).id : "";
      this.detailform.cardId = localStorage.getItem("cardId");
      this.detailform.cityCode = localStorage.getItem("cityCode");
      this.detailform.productId = this.$route.query.id;
      this.detailform.brandId = this.$route.query.brandId;
      this.getProductDetail();
    },
    // 获取商品详情
    async getProductDetail() {
      this.loading = true;
      const goodsData = await getGoodsDetail(this.detailform, this.specId);
      this.productDetaiLoad = true;
      if (goodsData) {
        this.detail = goodsData.target;
        this.productType = this.detail.productType
        if (this.detail.venueList && this.detail.venueList.length > 0) {
          this.detail.venueList[0].checked = true
        }
        this.specsLsit = goodsData.specsArr;
        this.setGoodsInfo(goodsData.defaultSpecs);
      } else {
        var timer = setInterval(() => {
          this.$router.back();
          clearInterval(timer);
        }, 1000)
      }
      this.loading = false;
    },
    // 去购物车
    goCar() {
      goMyCart(2);
    },
    /**
     * 打开规格选择内容页
     */
    specPopupOpen(params) {
      this.$refs.SpecPopupRecharge.open(params);
    },
    /**
     * 规格菜单点击加入【立即购买】执行函数
     */
    async handleSpecSubmit({ type, selectedSpec, deliveryData, rechargeAccount }) {
      this.setGoodsInfo(selectedSpec, selectedSpec.count);
      this.loading = true;
      await submitBuyGoodsInfo(
        type,
        { userId: this.userId, ...this.detailform },
        deliveryData,
        selectedSpec,
        this.detail,
        {rechargeAccount: rechargeAccount}
      );
      this.loading = false;
    },
    /**
     * 商品相关的data数据回填
     */
    setGoodsInfo(specInfo, count = 1) {
      const specInfo_ = specInfo || {};
      const { id, specifications, showPrice, ticketPrice, bannerList, coverImage, htmEditorList } = specInfo_;
      this.goodNum = count; // 购买数量
      this.specId = id || "";
      if (this.productType === '0') {
        this.selectGoods = ticketPrice ? `${ticketPrice}` : "暂无商品";
        this.chousetype = ticketPrice || "暂无商品";
      } else {
        this.selectGoods = specifications ? `${specifications}` : "暂无商品";
        this.chousetype = specifications || "暂无商品";
      }

      this.selectPrice = showPrice || "暂无价格";
      this.setBannerList(coverImage, bannerList, htmEditorList);
    },
    /**
     * 将规格图片推到banner图的主位上
     */
    setBannerList(specsImg, bannerList, htmEditorList) {
      // if (!specsImg) return;
      this.bannerList = Utils.isNoEmptyArr(bannerList) ? [specsImg, ...bannerList] : [specsImg];
      this.goodsDetailImgList = htmEditorList
    }
  },

  computed: {
    // 净化后的 description，防止 XSS
    sanitizedDescription() {
      return sanitizeHtml(this.detail?.description || '');
    }
  }
};
</script>

<style lang="scss" scoped>
.recharge-detail {
  background: #f8f8f8;
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 60px; // 为底部操作栏留出空间

  .banner-section {
    width: 100%;
    height: 100vw;
    position: relative;
    background: #fff;
    flex-shrink: 0;
    
    .banner-swipe {
      width: 100%;
      height: 100%;
    }

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info-section {
    background: #fff;
    padding: 16px;
    margin-bottom: 8px;
    flex-shrink: 0;

    .price-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .price {
        .price-value {
          font-size: 28px;
          font-weight: 600;
          color: #D23B2E;
          font-family: DIN;
        }
        .price-unit {
          font-size: 14px;
          color: #D23B2E;
          margin-left: 2px;
        }
      }

      .title-tag {
        padding: 4px 8px;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
      }
    }

    .product-name {
      margin-bottom: 12px;
      line-height: 1.4;

      .brand-name {
        font-size: 15px;
        color: #666;
        margin-right: 4px;
      }

      .name {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .tag-item {
        padding: 4px 8px;
        background: #f5f5f5;
        border-radius: 4px;
        font-size: 12px;
        color: #666;
      }
    }
  }

  .spec-section {
    background: #fff;
    margin-bottom: 8px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    flex-shrink: 0;

    .spec-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 16px;
      border-bottom: 1px solid #f5f5f5;
      cursor: pointer;
      transition: all 0.2s ease;
      position: relative;

      &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &:last-child {
        border-bottom: none;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      &:hover {
        background-color: #fafafa;
      }

      &:active {
        background-color: #f0f0f0;
        transform: scale(0.98);
      }

      .spec-label {
        display: flex;
        align-items: center;
        min-width: 60px;

        .label-text {
          font-size: 15px;
          color: #333;
          font-weight: 500;
        }
      }

      .spec-content {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: flex-end;
        gap: 10px;

        .spec-text {
          font-size: 14px;
          color: #666;
          text-align: right;
          max-width: 180px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.4;
        }
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: linear-gradient(135deg, #D23B2E, #FF6B5A);
        border-radius: 2px;
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      &:hover::after {
        opacity: 0.6;
      }
    }
  }

  .detail-section {
    background: #fff;
    padding: 16px;
    flex: 1;

    .section-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .header-text {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .description {
      font-size: 15px;
      color: #333;
      line-height: 1.7;
      margin-bottom: 20px;
      white-space: pre-wrap;
      word-break: break-word;

      :deep(p) {
        margin: 10px 0;
        font-size: 15px;
        line-height: 1.7;
        color: #333;
      }

      :deep(br) {
        content: "";
        display: block;
        margin: 8px 0;
      }

      :deep(img) {
        max-width: 100%;
        height: auto;
        margin: 10px 0;
        border-radius: 4px;
      }

      :deep(strong) {
        font-weight: 600;
        color: #222;
        font-size: 15px;
      }

      :deep(ul), :deep(ol) {
        padding-left: 20px;
        margin: 10px 0;
      }

      :deep(li) {
        margin: 5px 0;
        font-size: 15px;
        line-height: 1.7;
        color: #333;
      }
    }

    .image-list {
      .detail-image {
        width: 100%;
        margin-bottom: 8px;
        border-radius: 4px;
      }
    }

  }
}

// 底部操作栏样式优化
:deep(.van-goods-action) {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  
  .van-goods-action-button {
    height: 40px;
    font-size: 15px;
  }
}

.header-line {
  width: 3px;
  height: 16px;
  background: #D23B2E;
  margin-right: 8px;
  border-radius: 2px;
}
</style>
